import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"color":"var(--cm-color-text-regular)","cursor":"not-allowed"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "check-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "light",
    placement: "top",
    "show-after": 300,
    "hide-after": 500,
    disabled: _ctx.authStatus === _ctx.TerminalAuthStatus.normal
  }, {
    content: _withCtx(() => [
      (_ctx.authStatus === _ctx.TerminalAuthStatus.unauthorized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.isBasicServiceInJP)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarUnauthorizedTip', { name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name) })), 1),
                  _createTextVNode("  "),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    content: _ctx.$t('mySubscribe.freeBasicNoAdjustTip')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarConfigureNow')), 1)
                    ]),
                    _: 1
                  }, 8, ["content"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarUnauthorizedTip', { name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name) })), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", {
                    class: "cm-link-light",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAuth && _ctx.handleAuth(...args)))
                  }, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarConfigureNow')), 1)
                ], 64))
          ]))
        : (_ctx.authStatus === _ctx.TerminalAuthStatus.unsubscribed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarUnsubscribedTip', { areaType: _ctx.AreaTypeLabel[_ctx.areaType], name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name) })), 1),
              _createTextVNode("  "),
              _createElementVNode("span", {
                class: "cm-link-light",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toSubscribe && _ctx.toSubscribe(...args)))
              }, _toDisplayString(_ctx.$t('serviceSubscribe.detailsBarGoSubscribe')), 1)
            ]))
          : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["disabled"]))
}